import React, { createContext, useContext, useState } from 'react';

const SavedAnnouncementsCountContext = createContext();

export function SavedAnnouncementsCountProvider({ children }) {
  const [count, setCount] = useState(0);

  const updateCount = (newCount) => {
    setCount(newCount);
  };

  return (
    <SavedAnnouncementsCountContext.Provider value={{ count, updateCount }}>
      {children}
    </SavedAnnouncementsCountContext.Provider>
  );
}

export const useSavedAnnouncementsCount = () => useContext(SavedAnnouncementsCountContext);